const ACCESS_KEY = 'ksenus_access_token';
const REFRESH_KEY = 'ksenus_refresh_token';
const DEVICE_KEY = 'ksenus_device_token';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function getDeviceToken(): string | null {
  return localStorage.getItem(DEVICE_KEY);
}

export function setTokens(access: string, refresh: string): void {
  localStorage.setItem(ACCESS_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
}

export function setDeviceToken(token: string): void {
  localStorage.setItem(DEVICE_KEY, token);
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function isAuthenticated(): boolean {
  return getAccessToken() !== null;
}

export function decodeWorkspaceId(): string | null {
  const token = getAccessToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.workspace_id ?? null;
  } catch {
    return null;
  }
}

export function decodeRoles(): string[] {
  const token = getAccessToken();
  if (!token) return [];
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Array.isArray(payload.roles) ? payload.roles : [];
  } catch {
    return [];
  }
}

export function isWorkspaceAdmin(): boolean {
  return decodeRoles().includes('workspace_admin');
}

/** Mirrors maps-service's CurrentUser.can_manage_layers — the "map editor" tier:
 * create/edit/delete layers, maps, basemaps, dictionaries, connect external
 * sources. Наблюдатель (viewer) and Оператор (operator) both fall outside this. */
export function canManageLayers(): boolean {
  const roles = decodeRoles();
  return roles.includes('workspace_admin') || roles.includes('gis_admin');
}

/** Mirrors maps-service's CurrentUser.is_operator — may edit feature data on
 * specific layers they've been explicitly granted access to (gis.layer_permissions),
 * but can't manage layer/map/basemap/dictionary structure. */
export function isOperator(): boolean {
  return decodeRoles().includes('operator');
}

/** True for a Наблюдатель (viewer) or anyone else with no elevated role — read-only:
 * can view layers/objects/maps and use map tools, but no create/edit/delete of any
 * kind. Used to hide management UI entry points client-side (the backend is the
 * real enforcement boundary; this is purely to avoid dead-end buttons/routes). */
export function isReadOnly(): boolean {
  return !canManageLayers() && !isOperator();
}
